<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <SearchVehicleForm />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import SearchVehicleForm from '@/components/settings/consults/searchVehicle/SearchVehicleForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'SearchVehicle',
  components: {
    PageTitle,
    PageRowWrapper,
    SearchVehicleForm,
    LoadingPage
  }
}
</script>